import {
  THEME2_SEARCH_FILTER_BORDER_COLOR_DARK,
  THEME2_SEARCH_FILTER_BORDER_COLOR_LIGHT,
} from "utils/theme2MultiSelect";

/** Tema 2 rapor detay — panel / liste yüzeyleri ve çizgi renkleri */
export const getReportSurfaceColors = (isLightTheme, isTheme2 = false) => {
  if (isTheme2) {
    return {
      panelBg: isLightTheme ? "#ffffff" : "#27293d",
      itemBg: isLightTheme ? "#f7fafc" : "#27293d",
      border: isLightTheme ? THEME2_SEARCH_FILTER_BORDER_COLOR_LIGHT : THEME2_SEARCH_FILTER_BORDER_COLOR_DARK,
      rowBorder: isLightTheme ? "#ececec" : THEME2_SEARCH_FILTER_BORDER_COLOR_DARK,
      headerMuted: isLightTheme ? "#8d9498" : "rgba(255, 255, 255, 0.55)",
      bodyText: isLightTheme ? "#1d253b" : "rgba(255, 255, 255, 0.9)",
    };
  }

  return {
    panelBg: isLightTheme ? "#ffffff" : "#4a5568",
    itemBg: isLightTheme ? "#f7fafc" : "#4a5568",
    border: isLightTheme ? "#e2e8f0" : "rgba(255, 255, 255, 0.1)",
    rowBorder: isLightTheme ? "#ececec" : "rgba(255, 255, 255, 0.08)",
    headerMuted: isLightTheme ? "#8d9498" : "rgba(255, 255, 255, 0.55)",
    bodyText: isLightTheme ? "#1d253b" : "#ffffff",
  };
};
